import React from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";

export default function Summary_LoadingBar_Right({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);
  const hitRange = item.scale.ranges.find((scale) => scale.isHit);

  return (
    <Row style={{ height: Number(item.height), marginBottom: "" }}>
      <Col>
        <Row>
          <Col xs={3} className={"align-content-center"}>
            <Row>
              <Col className={`text-16 text-end ${isSub ? "_sub-scope-names-pdf" : "_main-scope-name-pdf"}`}>
                {item.name}
              </Col>
              <Col xs={"auto"} style={{ display: "inline-block", float: "right" }}>
                <div className={!isSub ? "_main-scope-score-pdf" : "_sub-scope-score-pdf"}>{elementScore}</div>
              </Col>
            </Row>
          </Col>
          <Col xs={9} className={"align-content-center"}>
            <ProgressBar
              variant={isSub ? "sub-scope" : "main-scope"}
              label={`%${elementScore} ${hitRange.text}`}
              now={elementScore}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
